import { notifyAuthFailure } from './authBus';

/**
 * Attach a response interceptor to an axios client instance that fires the
 * global auth:unauthorized event on a 401 response, triggering the reconnect
 * banner without coupling service files to AuthContext.
 */
export function attachAuthInterceptor(client) {
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        notifyAuthFailure();
      }
      return Promise.reject(error);
    },
  );
}
